import Container from "../common/Container";
import SectionLabel from "../common/SectionLabel";
import { skills, stats } from "../../data/portfolioData";

const About = () => {
  return (
    <section id="about">
      <Container>
        <SectionLabel number="01" label="About" />

        <div className="about-grid">
          <div>
            <h2 className="about-headline">
              Building <em>interfaces</em> that people actually love
            </h2>

            <p className="about-text">
              With a strong technical foundation from St. Petersburg State
              University of Telecommunications “Bonch Bruevich”, I'm passionate
              about building products where design and engineering work
              seamlessly together. I believe the best software feels effortless
              — intuitive, performant and beautifully crafted.
            </p>

            <p className="about-text">
              Based in Albania, I collaborate with global teams to build
              scalable frontend systems and deliver high-quality experiences for
              products used by millions.
            </p>

            <div className="about-stats">
              {stats.map((stat) => (
                <div className="stat-item reveal-on-scroll" key={stat.label}>
                  <div className="stat-num">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="about-skills">
            {skills.map((group) => (
              <div key={group.label}>
                <div className="skill-group-label">{group.label}</div>

                <div className="skill-tags">
                  {group.items.map((skill) => (
                    <span className="skill-tag" key={skill}>
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default About;
